const InfoRow = ({ label, value }) => (
  <div className='flex justify-between'>
    <span>{label}</span>
    <span className='font-medium'>{value}</span>
  </div>
)

export const ProgramCard = ({
  program,
  navigate,
  meta,
  formatDate,
  capitalize,
  statusStyles,
}) => {
  const {
    id,
    title,
    description,
    amount,
    is_per_household,
    recipients_count,
    created_at,
    date,
    status,
  } = program

  return (
    <div className='bg-white rounded-xl shadow border border-gray-200 p-6 flex flex-col hover:shadow-md transition-all duration-300'>
      <div className='mb-4'>
        <h3 className='text-lg font-semibold line-clamp-1 text-gray-900'>
          {title}
        </h3>
        <p className='text-sm text-gray-600 mt-1 line-clamp-2'>{description}</p>
      </div>

      <div className='space-y-2 text-sm text-gray-700 mb-4'>
        <InfoRow
          label='Amount'
          //   value={amount ? `₱${Number(amount).toLocaleString()}` : "—"}
          value={`₱${amount}`}
        />
        <InfoRow
          label='Beneficiary Type'
          value={is_per_household === 1 ? "Per Household" : "Per Individual"}
        />
        <InfoRow label='Recipients' value={recipients_count} />
        <InfoRow label='Date Created' value={formatDate(created_at || date)} />
      </div>

      <div className='mt-auto flex justify-between pt-2'>
        <span
          className={`px-2.5 py-1 text-xs font-medium rounded-full ${
            statusStyles[status] || "bg-gray-100 text-gray-600"
          }`}
        >
          {capitalize(status)}
        </span>

        <button
          onClick={() =>
            navigate(`/ayuda/${id}`, {
              state: program,
              meta,
            })
          }
          className='text-blue-600 text-[13px] underline'
        >
          View Details
        </button>
      </div>
    </div>
  )
}
